import React, {useContext, useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';

import {Container, Grid, LinearProgress} from '@mui/material';
import {PageHeader} from '../../common';
import {FetchContext, NavContext} from '../../contexts';
import {ProvinciaDetailsForm} from './components';
import {ProvinciaContext, ProvinciaProvider} from './ProvinciaContext';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingProvincia,
        getProvinciaAsync,

        isUpdatingProvincia,
        updateProvinciaAsync,

        isAddingProvincia,
        addProvinciaAsync,

        isLoadingRegioni,
        getRegioniAsync,
    } = useContext(ProvinciaContext)

    const {
        provincia,
    } = state;

    const {
        provinciaId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const provinciaDetailsFormActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (provincia) {
                    if (window.confirm("Confermare la modifica?")) {
                        await updateProvinciaAsync(provinciaId, data);
                    }
                } else {
                    if (window.confirm("Confermare l'inserimento?")) {
                        await addProvinciaAsync(data);
                        goBack();
                    }
                }
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingProvincia || isUpdatingProvincia || isAddingProvincia || isLoadingRegioni);
    }, [isLoadingProvincia, isUpdatingProvincia, isAddingProvincia, isLoadingRegioni])

    useEffect(() => {
        if (user && provincia) {
            addBreadcrumbToken(provincia.descrizione);
            getRegioniAsync(provincia.regione?.descrizione);
        }
    }, [provincia, user]);

    useEffect(() => {
        if (user) {
            if (!provinciaId) {
                addBreadcrumbToken("Aggiungi");
                getRegioniAsync();
            } else
                getProvinciaAsync(provinciaId);
        }
    }, [user]);

    if (!user)
        return <Container>
            <LinearProgress/>
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress/>}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            save
                            onSaveClick={saveClickHandler}
                            title="Provincia"
                            subtitle="Gestisci la provincia"/>
                    </Grid>
                    <Grid item xs={12}>
                        <ProvinciaDetailsForm
                            onActionClick={provinciaDetailsFormActionClickHandler}
                            disabled={isLoading}
                            formRef={formRef}/>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const ProvinciaPage = () => {

    return (
        <ProvinciaProvider>
            <PageContent/>
        </ProvinciaProvider>
    );
}